/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_course_attachments_messages_uploadingwithprogress2 = /** @type {(inputs: { progress: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`업로드 중... ${i?.progress}%`)
};

const en_course_attachments_messages_uploadingwithprogress2 = /** @type {(inputs: { progress: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading... ${i?.progress}%`)
};

const ja_course_attachments_messages_uploadingwithprogress2 = /** @type {(inputs: { progress: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アップロード中... ${i?.progress}%`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ progress: NonNullable<unknown> }} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_attachments_messages_uploadingwithprogress2 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_attachments_messages_uploadingwithprogress2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_attachments_messages_uploadingwithprogress2", locale)
	if (locale === "ko") return ko_course_attachments_messages_uploadingwithprogress2(inputs)
	if (locale === "en") return en_course_attachments_messages_uploadingwithprogress2(inputs)
	return ja_course_attachments_messages_uploadingwithprogress2(inputs)
};
export { course_attachments_messages_uploadingwithprogress2 as "course_attachments_messages_uploadingWithProgress" }